<template>
<transition name="Defi1">
  <div class="Defi1">
    <transition name="Defi1__hint">
      <div class="Defi1__hint" v-if="slugIsIn(['3', 'defi1:1', 'defi1:2']) && ready">
        <img :src="require('./img/assets/important.png')"/>
        <div v-html="trans('sentence')" v-if="slugIsIn(['defi1:1', 'defi1:2'])"/>
        <div v-html="trans('observe')" v-if="slugIsIn(['3'])"/>
      </div>
    </transition>
    <div class="Defi1__cover">
      <div 
        class="Defi1__oeuvre Vlazy" 
        v-lazy:background-image="oeuvre.image.sizes.large" 
        v-if="oeuvre.id != 214 && oeuvre.id != 226"/>
      <transition name="Defi1__infos">
        <div class="Defi1__infos">
          <div class="Defi1__infos-title">{{ oeuvre[oeuvre.titre_original].title }}</div>
          <div class="Defi1__infos-author">{{ author }} / {{ this.oeuvre.year }}</div>
        </div>
      </transition>
    </div>
    
    <VideoComp 
      :indice="(oeuvre.id == 214) ? 'adad' : 'patrick'" 
      v-if="slugIsIn(['3', 'defi1:1', 'defi1:2']) && oeuvre.id == 214"/>

    <Dropzone/>    
    <Words v-if="slugIsIn(['defi1:1', 'defi1:2'])"/>    
    <transition name="Defi1__end">
      <div
        v-if="completed && slugIsIn(['defi1:1', 'defi1:2'])"
        class="Btn Defi1__end"
        @click="next" v-html="trans('Global.btn.completed')" />
    </transition> 
  </div>
</transition>
</template>

<script>

import { Draggable } from 'gsap/all'
import Dropzone from './components/Dropzone'
import Words from './components/Words'
import TweenMax from 'gsap'
import VideoComp from './components/VideoComp'

export default {
  name: 'Defi1',
  components: { Dropzone, Words, VideoComp },
  data: () => ({
    completed: false,
    ready: false,
    dropzone: null,
    dropped: [ null, null, null ],
    author: '',
    zone: null,
  }),
  beforeDestroy() {
    this.words = []
    this.$store.commit('app/CURRENT_DRAG', null) 
  },
  created() {
    this.author = this.oeuvre.author.split('(2)')[0]
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
          this.ready = false
          this.$nextTick(() =>{
            if(this.slugIsIn(['defi1:1', 'defi1:2'])) 
              TweenMax.delayedCall(.5, ()=>this.Initialize()) 
            this.ready = true
          }) 
      }
    },
    drag_back(nw, od) {  
      const target = this.dropped[nw.choice]
      this.backDragCompleted(target, 0) 
      this.dropped[nw.choice] = null
    },
  },
  computed: {
    current_drag() { return this.$store.getters['app/current_drag'] },
    drag_back() { return this.$store.getters['app/drag_back'] },
  },
  translations: {
    fr: {
      sentence: "À toi de jouer.</br>Choisis trois mots correspondants</br>à cette œuvre.",
      observe: "Observe bien le portrait. Décris-le ensuite à Enki en glissant trois mots de ton choix sur l’image."
    },
    en: {
      sentence: "Your turn to play.</br>Choose three words that go with this artwork.",
      observe: "Look closely at the portrait. Then describe it to Enki by choosing three words about the artwork and dragging them onto the image."
    },
  },
  mounted() {
    this.$memory = null
    // TweenMax.delayedCall(1, ()=>this.Initialize())
  },
  methods: {
    enter(el, done) {
      TweenMax.from(el, 1, { alpha: 0, scale: .7, onComplete: done })
    },
    leave(el, done) {
      TweenMax.to(el, 1, { alpha: 0, scale: .7, onComplete: done })
    },
    Initialize() {
      this.createDrag()
    },
    createDrag() {
      const _this = this
      this.dropzone = '#dropzone'
      this.$drag = Draggable.create('.draggable', {
        bounds: window,
        zIndexBoost: false,
        onDragStart() {
           _this.getChoice() 
          _this.$store.commit('app/CURRENT_DRAG', { id: this.target.id, zone: _this.zone })
        },
        onDragEnd() {
          // const choice = _this.getChoice() 
          if(this.hitTest(_this.dropzone, '50%') && _this.zone != -1) 
            _this.dragCompleted(this.target, .5, _this.zone)   
          else 
            _this.backDragCompleted(this.target, .5) 
        }
      })
    },
    backDragCompleted(target, speed) {
      this.$store.commit('app/HIDE_BUBBLE') 
      TweenMax.to(target, speed, { 
        x: 0, 
        y: 0, 
        onComplete: ()=> { 
          this.isCompleted()
          this.$store.commit('app/CURRENT_DRAG', null) 
        }
      })
      
    },
    dragCompleted(target, speed, choice) {
      this.dropped[choice] = target
      this.$store.commit('app/DRAG_END', { id: target.id, choice: choice })
      this.isCompleted()
    },
    isCompleted() {
      TweenMax.delayedCall(.2, ()=>{
        this.completed = (this.getChoice() == -1) ? true : false
      })
    },
    getChoice() {
      let zone = -1
      _.each(this.dropped, (d, i)=>{
        if(this.dropped[1] == null)
          zone = 1
        else if(d == null && zone == -1) 
          zone = i
      })
      this.zone = zone
      return zone
    }, 
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Defi1
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  transition opacity 1s, transform 1s
  &-enter
  &-leave-active
    opacity 0
    transform scale(.7)

  &__infos
    position absolute
    text-align center
    bottom 100%
    margin-bottom 16px
    width 100%
    display flex
    flex-direction column
    justify-content center
    align-items center

    &-author
      font-size 14px
      font-weight 300
      text-transform uppercase

    &-title
      font-size 16px
      text-transform uppercase
      font-style italic
      max-width 70vw

  &__end
    transition opacity .5s, transform .5s
    &-enter
    &-leave-active
      opacity 0
      transform translateY(20px)

  &__submit
    transition opacity .5s, transform .5s
    position absolute
    bottom inherit
    top 5px
    right 5px
    &-enter
    &-leave-active
      opacity 0
      transform translateX(-20px)

  &__cover
    width 100vw
    max-width 700px
    height 400px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)

    +max-screen-height(tablet-portrait)
      width 100%
      height 40%
      max-height 400px

  &__oeuvre
    width 100vw
    max-width 600px
    height 400px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background-size contain
    background-position center center
    background-repeat no-repeat

    +max-screen-height(tablet-portrait)
      height 100%
      width 100%

  &__hint
    position absolute
    min-width 400px
    max-width 600px
    background black
    padding 16px
    border-radius 16px
    left 50%
    transform translateX(-50%)
    margin-top 80px
    text-align center
    color white
    bottom 48px
    opacity 1
    transition opacity 1s
    transition-delay 1s
    &-enter
    &-leave-active
      opacity 0

    +max-screen-height(tablet-portrait)
      font-size 16px
      line-height 22px
      padding 12px
      min-width 360px
      border-radius 8px

    & img 
      position absolute
      top -15px
      left -16px

      +max-screen-height(tablet-portrait)
        width 28px
        left -13px



  &__words
    position absolute
    left 20px
    top 50%
    transform translateY(-50%)

  &__word
    margin 14px 20px
    color white
    background-color rgba(0, 0, 0, 0.65)
    border-radius 25px
    height 44px
    font-weight 500
    font-size 18px
    line-height 47px
    text-align center
    padding 0 15px
    width 200px
    transition all 0.25s ease-out
    min-width 100px
    &.edited
      color #7c76ff
    &-enter
    &-leave-active
      opacity 0
      transform translateY(50px)

  &__inputs-container
    position absolute
    bottom 25px
    left 50%
    transform translateX(-50%)
    transition opacity 1s, transform 1s
    &-enter
    &-leave-active
      opacity 0
      transform translate(-50%, 100px)

  &__input
    font-size 22px
    border none
    color white
    width 420px
    height 54px
    background-color rgba
    border-radius 32px
    padding 0 22px
    &::placeholder
      color rgba(white, .5)
      opacity 1

  &__warning
    position absolute
    top -90px
    text-align center
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0

</style>



// WEBPACK FOOTER //
// src/components/defis/Defi1.vue